<template>
	<div class="menu-frame-page module-container" :class="moduleContainerClass">
		<template v-if="moduleList.length">
			<!-- 移动端视图 -->
			<template v-if="isMobile">
				<!-- 菜单栏 -->
				<div v-if="showMobileHeader" class="mob-menu-bar-wrapper">
					<CMobileTabs :options="moduleList" :active.sync="activeModuleId" syncKey="moduleId" />
				</div>
				<!-- 内容区 -->
				<div class="mob-module-content-wrapper">
					<SimpleVScroll>
						<template v-for="item in moduleList">
							<SmartDisplayC
								v-if="activeModuleId === item.moduleId"
								:key="item.moduleId"
								:compId="getModuleId(item)"
								mode="mob-full"
								v-bind="getModuleProps(item)"
							/>
						</template>
					</SimpleVScroll>
				</div>
			</template>

			<!-- PC 端视图 -->
			<template v-else>
				<ContentPad>
					<!-- 菜单栏 -->
					<div v-if="showPCHeader" class="pc-menu-bar-wrapper">
						<el-tabs v-model="activeModuleId">
							<el-tab-pane
								v-for="item in moduleList"
								:label="item.name"
								:name="item.moduleId"
								:key="item.moduleId"
								lazy
							/>
						</el-tabs>
					</div>
					<!-- 内容区 -->
					<template v-for="item in moduleList">
						<div
							v-if="activeModuleId === item.moduleId"
							:key="item.moduleId"
							:class="['pc-module-main', 'module-id-' + item.moduleId]"
						>
							<SmartDisplayC :compId="getModuleId(item)" mode="full" v-bind="getModuleProps(item)" />
						</div>
					</template>
				</ContentPad>
			</template>
		</template>
		<!-- 空状态 -->
		<Empty v-else class="modules-empty-wrap" />
	</div>
</template>

<script>
export default {
	name: 'MenuFrame'
};
</script>
<script setup>
import { computed, getCurrentInstance, ref } from 'vue';
import { SimpleVScroll } from '@rebuild/components/scroll';
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';
import { useStore } from '@/utils/vue-api';
import { useStoreCore } from '@/hooks';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';
import { IRSTORE_T_VIEW } from '@/utils/track';
import { useCommonData } from '@/hooks';

const vm = getCurrentInstance();
const store = useStore();

const isMobile = computed(() => store.getters.isMobileMode);

const { isFlowXTmpl, isFlowTmpl } = useCommonData();
const moduleContainerClass = computed(() => {
	const classList = [];
	if (isMobile.value) {
		classList.push('is-mobile');
	} else {
		classList.push('is-pc');
	}
	if (isFlowTmpl.value) {
		classList.push('flow_pc');
	}
	if (isFlowXTmpl.value) {
		classList.push('flowX_pc');
	}
	return classList;
});

const { shouldShowUI } = useStoreCore();
const showMobileHeader = computed(() => {
	if (!shouldShowUI('moduleBar')) return false;
	const len = moduleList.value.length;
	if (len <= 1) return false;
	return true;
});
const showPCHeader = computed(() => {
	if (!shouldShowUI('moduleBar')) return false;
	return true;
});

const moduleList = ref([]);
const activeModule = ref();
const activeModuleId = ref();
const { getModuleId, getModuleProps, isCustomM } = useModuleAttrs();

const addViewTrack = () => {
	if (!activeModule.value) return;
	const name = activeModule.value.name;
	const isCustom = isCustomM(activeModule.value);
	const params = {
		浏览模块名称: name,
		浏览模块类型: isCustom ? '自定义模块' : '系统默认模块',
		企业ID: resolveStoreId(),
		页面ID: resolvePageId()
	};
	IRSTORE_T_VIEW(282, { params });
};

// 根据组件ID去重
const deduplicateModuleList = list => {
	const seenModuleIds = new Set();
	const result = [];
	for (const item of list) {
		if (!seenModuleIds.has(item.moduleId)) {
			seenModuleIds.add(item.moduleId);
			result.push(item);
		}
	}
	return result;
};
const initMenuRender = () => {
	const menuId = vm.proxy.$route.params?.menuId;
	const menus = store.getters.getNormalMenus || [];
	const targetMenu = menus.find(menu => menu.id == menuId);

	const uniqueModuleList = deduplicateModuleList(targetMenu?.moduleVOS || []);
	const list = uniqueModuleList;
	moduleList.value = list;

	let activeModuleItem;
	const moduleId = vm.proxy.$route.params?.moduleId;
	if (moduleId) {
		activeModuleItem = list.find(item => item.moduleId === moduleId);
	} else {
		activeModuleItem = list[0];
	}

	activeModule.value = activeModuleItem;
	activeModuleId.value = activeModuleItem?.moduleId;
};
initMenuRender();
addViewTrack();
</script>

<style lang="less" scoped>
.module-container.is-mobile {
	display: flex;
	flex-direction: column;
	height: 100%;

	.mob-menu-bar-wrapper {
		flex-shrink: 0;
	}
	.mob-module-content-wrapper {
		flex: 1;
		height: 0;
	}
}
.module-container {
	.pc-menu-bar-wrapper {
		position: sticky;
		top: 0px;
		z-index: 19;
		border-radius: 2px 2px 0 0;
		background: linear-gradient(95deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 100%);
		border-bottom: 1px solid #f2f3f5;
		backdrop-filter: blur(20px);
		overflow: hidden;
	}
}
.module-container {
	&.flow_pc,
	&.flowX_pc {
		.pc-module-main {
			padding-top: 32px;
			padding-bottom: 67px;
		}
	}
}
</style>
